export function formatPhoneNumber(value: string): string {
  // Remove all non-numeric characters
  let cleaned = value.replace(/\D/g, '');

  // Remove leading 1 (country code) if present
  if (cleaned.startsWith('1') && cleaned.length > 1) {
    cleaned = cleaned.slice(1);
  }

  // Format as (xxx) xxx-xxxx
  if (cleaned.length <= 3) {
    return cleaned;
  } else if (cleaned.length <= 6) {
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3)}`;
  } else {
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6, 10)}`;
  }
}
